store.quickOrder = {
	stats: null,
	strings: [],
	init: function() {
		$(document).on('click', '.ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-title, .ui-datepicker-calendar', function (e) {
			e.stopPropagation();
		});

		store.quickOrder.strings.storeQuickOrderIsEmpty = $('#storeQuickOrderForm').html();

		store.quickOrder.initAutocomplete();
		store.quickOrder.initDatepicker();
		store.quickOrder.initCustomerStats();

		setTimeout(function() {
			store.quickOrder.initEvents();

			if (!store.quickOrder.hasItemsInStorage()) {
				// Render items from past year
				var to = new Date();
				var from = new Date();
				from.setFullYear(from.getFullYear() - 1);

				var fromString = from.getDate() + '.' + from.getMonth() + '.' + from.getFullYear();
				var toString = to.getDate() + '.' + to.getMonth() + '.' + to.getFullYear();
				store.quickOrder.importByRange(fromString, toString);
			}
			else {
				store.quickOrder.renderFromStorage();
			}
		}, 1000);
	},
	initEvents: function() {
		$('#storeQuickOrderImport').on('submit', function(e) {
			$('.dropdown-toggle').dropdown('toggle');

			e.preventDefault();

			var $form = $(this),
				formValues = [],
				values = $form.serializeArray();

			for (var i = 0, iMax = values.length; i < iMax; i++) {
				formValues[values[i].name] = values[i].value;
			}

			if (formValues.import) {
				if (formValues.import === 'lastorder') {
					if (confirm('Að sækja seinustu pöntun hreinsar út núverandi pöntun. Halda áfram?')) {
						store.quickOrder.importLastOrder();
					}
				}
				else {
					if (confirm('Að sækja eldri pantanir hreinsar út núverandi pöntun. Halda áfram?')) {
						store.quickOrder.importByRange(formValues.from, formValues.to);
					}
				}
			}
		});

		$('#storeQuickOrderFormReset').on('click', function(e) {
			e.preventDefault();

			if (confirm('Ertu viss um að þú viljir hreinsa pöntunina?')) {
				store.quickOrder.clear();
			}
		});

		$('#storeQuickOrderFormSubmit').on('click', function(e) {
			e.preventDefault();

			$.ajax({
				url: '/_/' + moya.lang + '/store/cart/bulkadd',
				method: 'post',
				data: $('#storeQuickOrderForm').serializeArray()
			}).done(function() {
				// Update miniCart
				store.cart.box();

				// Update mediumCart
				$.get(store.url(store.action.cartMedium, ''), function (data) {
					$('.cartBoxMedium').replaceWith(data.html);
					$('#storeCartBox .miniCart').trigger('click');
					store.quickOrder.clear();

				}, 'json');
			});
		});

		store.quickOrder.bindRemoveProduct();
	},
	initAutocomplete: function() {
		var $element = $('#storeQuickOrderSearch');
		if ($element.length) {
			$element.autocomplete({
				source: function( request, response ) {
					$.ajax({
						url: '/' + moya.lang + '/moya/store/api/autocomplete',
						dataType: "json",
						data: {
							query: encodeURIComponent(request.term)
						},
						success: function( data ) {
							response( data );
						}
					});
				},
				minLength: 2, // Need to search for "ís"
				select: store.quickOrder.autocompleteSelect,
				focus: store.quickOrder.autocompleteFocus,
				close: store.quickOrder.autocompleteClose,
			}).autocomplete( "instance" )._renderItem = store.quickOrder.autocompleteRender;
		}
	},

	initDatepicker: function() {
		var $element = $('.datepicker', '#storeQuickOrderImport');
		if ($element.length) {
			$element.datepicker({
				dateFormat: 'dd.mm.yy',
				onSelect: function(date, obj) {
					var $this = $(this);
					if ($this.attr('name') === 'from') {
						var $to = $('.datepicker[name="to"]', '#storeQuickOrderImport');
						$to.datepicker('option', 'minDate', date);
					}

					$('#storeQuickOrderImportDate').trigger('click');
				}
			});
		}
	},

	initCustomerStats: function() {
		store.quickOrder.customerStats = store.quickOrder.loadFromStorage('customerStats');

		if (!store.quickOrder.customerStats.length) {
			$.ajax({
				url: '/' + moya.lang + '/moya/store/api/customerstats',
				method: 'get'
			}).done(function(r) {
				if (r) {
					store.quickOrder.saveToStorage('customerStats', r);
					store.quickOrder.customerStats = r;
				}
			});
		}
	},

	importLastOrder: function() {
		store.quickOrder.renderLoading();

		$.ajax({
			url: '/' + moya.lang + '/moya/store/api/lastorder',
			method: 'get'
		}).done(function (r) {
			if (r) {
				store.quickOrder.clear();

				$.each(r, function (idx, item) {
					store.quickOrder.addItemToStorage(item);
				});

				store.quickOrder.renderFromStorage();
				store.quickOrder.bindRemoveProduct();
			}
			else {
				moya.message.add('Engin pöntun fannst');
				$('#storeQuickOrderGetLastOrder').addClass('disabled');
			}
		});
	},

	importByRange: function(from, to) {
		store.quickOrder.renderLoading();

		$.ajax({
			url: '/' + moya.lang + '/moya/store/api/orderitems',
			method: 'get',
			data: {
				from: from,
				to: to
			}
		}).done(function (r) {
			if (r) {
				store.quickOrder.clear();

				$.each(r, function (idx, item) {
					store.quickOrder.addItemToStorage(item);
				});

				store.quickOrder.renderFromStorage();
				store.quickOrder.bindRemoveProduct();
			}
			else {
				moya.message.add('Engin pöntun fannst');
				$('#storeQuickOrderGetLastOrder').addClass('disabled');
			}
		});
	},

	bindRemoveProduct: function() {
		$('.product__remove', '#storeQuickOrderForm').on('click', function() {
			var $this = $(this),
				$product = $this.parents('.product'),
				items = store.quickOrder.getItemsFromStorage();

			for (var i = 0, iMax = items.length; i < iMax; i++) {
				if (items[i].externalId == $product.data('externalid')) {
					items.splice(i, 1);
					break;
				}
			}
			store.quickOrder.saveToStorage('items', items);

			$product.remove();
		});
	},

	getProductCustomerStats: function(reference) {
		var string = '',
			label = '',
			value = '',
			orderItems = store.quickOrder.customerStats.orderItems;

		if (orderItems.allTime[reference]) {
			var history = orderItems.allTime[reference].history;
			var historyArray = Object.keys(history).map(function(key) {
				return [Number(key), history[key]];
			});

			var last = historyArray.slice(-1).pop();

			if (last) {
				label = 'Last order: ';
				if (moya.lang === 'is') { label = 'Seinast pantað: ';}
				var date = new Date(last[0]*1000);
				var dateString = date.getDate() + '.' + date.getMonth() + '.' + date.getFullYear();
				var qty = last[1];

				string += '<span class="stat">' + label + ' ' + dateString + ' <span class="stat__value">' + qty + '</span> stk.</span>';
			}

		}
		if (orderItems.oneMonth[reference]) {
			label = '1 month: ';
			if (moya.lang === 'is') { label = '1 mán: ';}
			value = orderItems.oneMonth[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}
		if (orderItems.sixMonths[reference]) {
			label = '6 months: ';
			if (moya.lang === 'is') { label = '6 mán: ';}
			value = orderItems.sixMonths[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}
		if (orderItems.twelveMonths[reference]) {
			label = '12 months: ';
			if (moya.lang === 'is') { label = '12 mán: ';}
			value = orderItems.twelveMonths[reference].totalOrdered;
			string += '<span class="stat">' + label + '<span class="stat__value">' + value + '</span>' + ' stk.</span>';
		}

		if (string) {
			return '<div class="product__stats">' + string + '</div>';
		}
	},

	autocompleteSelect: function(event, ui) {
		if (ui.item) {
			store.quickOrder.addItemToStorage(ui.item, true, function() {
				store.quickOrder.renderFromStorage();
				store.quickOrder.enableButtons();
				store.quickOrder.bindRemoveProduct();
				$('#storeQuickOrderForm').focus();
			});
		}

		return false;
	},
	autocompleteFocus: function(event, ui) {
		// Do nothing
		return false;
	},
	autocompleteClose: function(event, ui) {
		// Do nothing
		return false;
	},
	autocompleteRender: function( ul, item ) {
		var $li = $( "<li>" ),
			img = '';

		if (item.imageId) {
			img = '<img src="/static/store/images/xs/product_' + item.imageId + '.' + item.imageExt.toLowerCase() + '">';
		}

		$li.append('<span class="result__image">' + img + '</span>');

		if (item.vendorName) {
			$li.append('<span class="result__label">' + item.vendorName + '</span>');
		}

		$li.append('<span class="result__sublabel">' + item.variantName[moya.lang] + '</span>');
		$li.append('<span class="result__reference">' + item.reference + '</span>');
		$li.wrapInner('<div class="result">').appendTo( ul );

		return $li;
	},

	addItemToStorage: function(item, prepend, callback) {
		items = store.quickOrder.getItemsFromStorage();
		if (prepend) {
			items.unshift(item);
		}
		else {
			items.push(item);
		}
		items = store.quickOrder.saveToStorage('items', items);

		if (callback) {
			callback();
		}
	},

	addItemQuantityToStorage: function(quantity, itemId) {
		items = store.quickOrder.getItemsFromStorage();
		$.each(items, function(idx, item) {
			if (item.id === itemId) {
				item.quantity = quantity;
				items[idx] = item;
				return true;
			}
		});
		items = store.quickOrder.saveToStorage('items', items);
	},

	clearItemStorage: function() {
		window.localStorage.removeItem('items');
		window.localStorage.removeItem('customerStats');
	},

	clear: function() {
		store.quickOrder.clearItemStorage();
		store.quickOrder.renderFromStorage();
	},

	getItemsFromStorage: function() {
		return store.quickOrder.loadFromStorage('items');
	},

	hasItemsInStorage: function() {
		return (store.quickOrder.getItemsFromStorage().length > 0);
	},

	loadFromStorage: function(key) {
		var values = window.localStorage.getItem(key);

		if (!values) {
			values = [];
		}
		else {
			values = JSON.parse(values);
		}

		// Check if data has a timestamp
		if (values.lastUpdated) {
			var now = Date.now() / 1000 | 0;
			// If data is older than 24 hrs invalidate and return nothing
			if (now && now > values.lastUpdated + 86400) {
				values = [];
			}
		}

		return values;
	},

	saveToStorage: function(key, value) {
		window.localStorage.setItem(key, JSON.stringify(value));
	},

	enableButtons: function() {
		$('#storeQuickOrderFormSubmit').removeClass('disabled');
		$('#storeQuickOrderFormReset').removeClass('disabled');
	},

	disableButtons: function() {
		$('#storeQuickOrderFormSubmit').addClass('disabled');
		$('#storeQuickOrderFormReset').addClass('disabled');
	},

	renderLoading: function() {
		$form = $('#storeQuickOrderForm');
		if ($form) {
			var string = 'Loading products...';
			if (moya.lang === 'is') {
				string = 'Hleð inn vörum...';
			}
			$form.html(string);
		}
	},

	renderFromStorage: function() {
		$form = $('#storeQuickOrderForm');
		if ($form) {
			if (store.quickOrder.hasItemsInStorage()) {
				$form.html('');
				var items = store.quickOrder.getItemsFromStorage();

				store.quickOrder.enableButtons();
				store.quickOrder.renderSorter().appendTo($form);
				var $products = $('<div class="products">').appendTo($form);

				var inactiveLabel = 'Product no longer exists';
				if (moya.lang === 'is') {
					inactiveLabel = 'Vara ekki lengur fáanleg';
				}

				$.each(items, function(index, item) {
					var $product = $('<div class="product" data-externalid="'+item.externalId+'">'),
						img = '',
						imgUrl = '';

					if (item.imageId) {
						imgUrl = '/static/store/images/xs/product_' + item.imageId + '.' + item.imageExt.toLowerCase();
						img = '<a href="'+imgUrl+'" class="fancybox" style="background-image:url('+imgUrl+')"></a>';
					}
					if (item.active < 1) {
						$product.addClass('inactive');
						$product.attr('title', inactiveLabel);
					}

					$product.append('<div class="product__image">' + img + '</div>');

					store.quickOrder.renderProductDetails(item).appendTo($product);
					store.quickOrder.renderProductAside(item).appendTo($product);

					$product.append('<div class="product__remove"></div>');

					$product.appendTo($products);
				});
			}

			$('#storeQuickOrderSearch').val('').focus();

			$('.product__qty input[type="number"]', '#storeQuickOrderForm').on('keyup input', function(e) {
				e.preventDefault();
				var $this = $(this),
					id = $this.attr('name').replace(/\D+/g, '');

				if ($this.val() > 0) {
					$this.addClass('active');
				}
				else {
					$this.val('').removeClass('active');
				}

				store.quickOrder.addItemQuantityToStorage($this.val(), id);
			});
		}
	},

	renderSorter: function() {
		var $sorter = $('<div class="sorter">Raða eftir:</div>');
		$('<a href="#" onclick="return store.quickOrder.sortByTitle();">Vöruheiti</a>').appendTo($sorter);
		$('<a href="#" onclick="return store.quickOrder.sortByReference();">Vörunúmeri</a>').appendTo($sorter);
		return $sorter;
	},

	renderProductDetails: function(item){
		var $details = $('<div class="product__details">');

		if (item.vendorName) {
			$details.append('<span class="product__label">' + item.vendorName + '</span>');
		}

		if (item.url) {
			$details.append('<span class="product__sublabel"><a href="' + item.url + '" target="_blank">' + item.variantName[moya.lang] + '</a></span>');
		}
		else {
			$details.append('<span class="product__sublabel">' + item.variantName[moya.lang] + '</span>');
		}

		if (item.ExtraDesc5) {
			var count = 1;
			if (item.ExtraDesc5.indexOf('KS') === 0) {
				count = item.ExtraDesc5.replace(/\D+/g, '');
			}
			$details.append('<span class="product__lot">' + count + ' stk. í pakka</span>');
		}
		if (item.weight) {
			$details.append('<span class="product__weight">' + item.weight + ' kg.</span>');
		}

		var $priceDetails = $('<div class="product__priceDetails">');

		if (item.price) {
			$priceDetails.append('<span class="product__price">Listaverð:' + item.price.substring(0, item.price.indexOf('.')) + ' kr.</span>');
		}
		if (item.discountPrice) {
			$priceDetails.append('<span class="product__discountPrice">Mitt verð: ' + Math.round(item.discountPrice) + ' kr.</span>');
		}
		if (item.price && item.discountPrice) {
			var discount = 1 - Math.round(item.discountPrice) / item.price.substring(0, item.price.indexOf('.'));
			$priceDetails.append('<span class="product__discountPercentage">Afsláttur: ' + Math.round(discount * 100) + ' %.</span>');
		}

		if (item.discountPriceText) {
			$priceDetails.append('<span class="product__discountPriceText"><span>Tilboð: </span>' + item.discountPriceText + '</span>');
		}

		$details.append($priceDetails);


		$details.append(store.quickOrder.getProductCustomerStats(item.reference));

		return $details;
	},

	renderProductAside: function(item){
		var $aside = $('<div class="product__aside">');

		$aside.append('<span class="product__reference">Vnr. ' + item.reference + '</span>');

		var $qtyWrap = store.quickOrder.renderProductQtyWrap(item);
		$aside.append($qtyWrap);
		$aside.append('<input type="hidden" name="price[' + item.id + ']" value="' + item.basePriceId + '">');
		$aside.append('<input type="hidden" name="category[' + item.id + ']" value="' + item.categoryId +'">');

		return $aside;
	},

	renderProductQtyWrap: function(item) {
		var step = 1;
		var qtyLabel = 'Quantity';
		var outOfStockLable = 'Out of stock';
		var $qtyWrap = $('<span class="product__qty">');

		if (moya.lang === 'is') {
			qtyLabel = 'Fjöldi';
			outOfStockLable = 'Vara uppseld';
		}

		if (item.ExtraDesc5) {
			if (item.ExtraDesc5.indexOf('KS') === 0) {
				step = item.ExtraDesc5.replace(/\D+/g, '');
			}
		}

		var $qtyInput = $('<input type="number"/>');
		$qtyInput.prop('name', 'qty[' + item.id + ']');
		$qtyInput.prop('step', step);
		$qtyInput.prop('max', item.stock);
		if (item.quantity && item.quantity > 0) {
			$qtyInput.val(item.quantity);
			$qtyInput.addClass('active');
		}
		$qtyWrap.append(qtyLabel);
		$qtyWrap.append($qtyInput);
		if (item.active < 1 || item.stock < 1) {
			$qtyInput.prop('disabled', 'disabled');
			$qtyInput.attr('title', outOfStockLable);
		}
		return $qtyWrap;
	},

	sortByTitle: function() {
		var $form = $('#storeQuickOrderForm'),
			$products = $form.find('.product');

		$products.sort(function(a, b) {
			var aid = $(a).find('.product__sublabel').text().toLowerCase(),
				bid = $(b).find('.product__sublabel').text().toLowerCase();

			if (aid > bid) {
				return 1;
			}

			if (aid < bid) {
				return -1;
			}

			return 0;
		});

		$form.find('.products').html($products);
		store.quickOrder.bindRemoveProduct();
		return false;
	},

	sortByReference: function() {
		var $form = $('#storeQuickOrderForm'),
			$products = $form.find('.product');

		$products.sort(function(a, b) {
			var aid = parseInt($(a).data('externalid')),
				bid = parseInt($(b).data('externalid'));

			if (aid > bid) {
				return 1;
			}

			if (aid < bid) {
				return -1;
			}

			return 0;
		});

		$form.find('.products').html($products);
		store.quickOrder.bindRemoveProduct();
		return false;
	}
};

